import { urlBase } from "./config";
import axiosInstance from "../services/config/axiosinstance";

async function getSalesConsolidated({
  jwt,
  search,
  eventId,
  currentIndex,
  itemsPerPage,
  columnSearch,
}) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/events/${eventId}/payments/transactions?offset=${currentIndex}&limit=${itemsPerPage}&search=${
        search ? search : ""
      }&type=${columnSearch}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function deleteSalesConsolidated({ jwt, idSale }) {
  try {
    const config = {
      method: "post",
      url: `${urlBase}/payments/transactions/${idSale}/cancel`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

// cancela a fatura IUGU atual da venda e gera outra com o mesmo prazo, a partir de hoje;
// `processorId` é a fatura exibida (a API recusa com 409 se a venda já tiver outra)
async function reissueInvoice({ jwt, idSale, processorId }) {
  try {
    const config = {
      method: "post",
      url: `${urlBase}/payments/transactions/${idSale}/reissue-invoice`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      data: { processor_id: processorId },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

// pagamento offline (pago fora da IUGU): cancela a fatura atual e marca a venda como paga;
// `processorId` é a fatura exibida (a API recusa com 409 se a venda já tiver outra)
async function markOfflinePaid({ jwt, idSale, processorId }) {
  try {
    const config = {
      method: "post",
      url: `${urlBase}/payments/transactions/${idSale}/offline-payment`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      data: { processor_id: processorId },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function getSalesAnalitics({
  jwt,
  search = "",
  eventId,
  currentIndex,
  itemsPerPage,
  columnSearch,
}) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/events/${eventId}/payments/transactions/analitics?offset=${currentIndex}&limit=${itemsPerPage}&search=${
        search ? search : ""
      }&type=${columnSearch}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function getSalesDetails({ jwt, idSale }) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/payments/transactions/${idSale}/details`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

// produtos e participantes de um lote de vendas (até 100 ids), para a exportação XLSX
async function getSalesExportDetails({ jwt, ids }) {
  try {
    const config = {
      method: "post",
      url: `${urlBase}/payments/transactions/export-details`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      data: { ids },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function getSalesProducts({ jwt, idSale }) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/payments/transactions/${idSale}/products`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function getSalesAttendees({ jwt, idSale }) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/payments/transactions/${idSale}/attendees`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function getSalesEmail({ jwt, idSale }) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/payments/transactions/${idSale}/emails`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

async function resendEmail({ jwt, id }) {
  try {
    const config = {
      method: "post",
      url: `${urlBase}/payments/transactions/emails/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

// Dashboard de Vendas: todos os números do evento em uma ida só. A agregação é
// feita no banco pela admin-api — a tela não soma listagem paginada.
async function getSalesDashboard({ jwt, eventId }) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/events/${eventId}/payments/dashboard`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response;
  }
}

export {
  getSalesConsolidated,
  getSalesAnalitics,
  deleteSalesConsolidated,
  getSalesDetails,
  reissueInvoice,
  markOfflinePaid,
  getSalesExportDetails,
  getSalesProducts,
  getSalesAttendees,
  getSalesEmail,
  resendEmail,
  getSalesDashboard,
};
